import RentalFormModal from "../common/Rentals/RentalFormModal";

const ADD_UNIT_CONFIG = {
  showDestinationField: false,
  showLatLng: true,
  showGuideName: false,
  title: "Unit",
  defaultDestinationId: 0,
  showLogs: false,
  messageOnAdd: "Added Successfully",
  messageOnEdit: "Updated Successfully",
  redirectPath: "/units",
};

const AddUnit = () => {
  return <RentalFormModal config={ADD_UNIT_CONFIG} />;
};

export default AddUnit;